<template>
  <nav id="Nav">
    <div ref="NavInner" class="NavInner" :style="style">
      <div
        v-for="car in cars"
        :key="car.name"
        :class="getContainerClasses(car.name)"
        @click="$emit('car-change', car.name)"
      >
        <div class="Year">{{ findCarYear(car.name) }}</div>
        <img :src="car.img" />
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Nav',

  props: {
    cars: { type: Array, required: true },
    generations: { type: Array, required: true },
    active: { type: Number, required: true }
  },

  data: () => ({
    style: {}
  }),

  watch: {
    active(val) {
      if (val >= 0) {
        this.updateStyle();
      }
    }
  },

  created() {
    window.addEventListener('resize', this.updateStyle);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateStyle);
  },

  mounted() {
    setTimeout(() => {
      this.updateStyle();
    }, 50);
  },

  methods: {
    findCarYear(carName) {
      const gen = this.generations.find(g => g.models.filter(m => m.name === carName).length > 0);
      if (gen) {
        return gen.start;
      }
      return '';
    },

    getContainerClasses(name) {
      let classes = 'CarContainer';
      const idx = this.cars.findIndex(x => x.name === name);

      if (idx === this.active) {
        classes += ' CarActive';
      } else if (idx === this.active + 1 || idx === this.active - 1) {
        classes += ' CarNear';
      }

      return classes;
    },

    updateStyle() {
      this.style = {};
      const wrapper = this.$refs.NavInner;

      if (wrapper) {
        const childs = wrapper.childNodes;
        const childsArray = [...childs];

        const offset = childsArray
          .slice(0, this.active + 1)
          .map(x => x.clientWidth)
          .reduce((a, v, idx) => a - (idx === 0 ? v / 2 : v), 0 + window.innerWidth / 2);

        this.style.transform = `translate3d(${offset}px, 0, -0)`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.NavInner {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  transition: 500ms transform ease-in-out;

  .CarContainer {
    position: relative;
    height: 80%;
    padding: 0 5px;

    // Year span animation
    &:hover .Year {
      visibility: visible;
      background: rgb(0, 0, 0, 0.8);

      &:after {
        border-top: solid 10px rgb(0, 0, 0, 0.8);
      }
    }

    // Image overlay animation
    &:hover::after {
      background: rgb(87, 87, 87, 0);
    }

    .Year {
      visibility: hidden;
      cursor: pointer;
      width: calc(100% - 10px);
      position: absolute;
      top: -60px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      font-weight: bold;
      color: white;
      padding: 10px 0;
      border-radius: 5px;
      background: rgb(0, 0, 0, 0);
      transition: background 500ms ease-in-out;

      // Triangle
      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-top: solid 10px rgb(0, 0, 0, 0);
        border-left: solid 5px transparent;
        border-right: solid 5px transparent;
        transition: border-top 500ms ease-in-out;
      }
    }

    img {
      display: block;
      width: auto;
      height: 100%;
    }

    // Image overlay
    &:after {
      position: absolute;
      content: '';
      cursor: pointer;
      top: 0;
      left: 5px;
      width: calc(100% - 10px);
      height: 100%;
      display: block;
      background: rgb(87, 87, 87, 1);
      transition: background 500ms ease-in-out;
    }

    &.CarActive:after {
      background: rgb(87, 87, 87, 0);
    }

    &.CarNear:after {
      background: rgb(87, 87, 87, 0.5);
    }
  }
}
</style>
